import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SuperscriptIcon(props: IconProps) {
    return <Icon {...props} iconKey={"superscript"}/>
}
